import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { blogPosts } from '../data/pagesData';
import { ArrowRight } from 'lucide-react';

const NewsroomPage = () => {
  const newsItems = blogPosts.filter(p => p.category === 'Fundraising' || p.category === 'Partnerships' || p.category === 'Compliance');
  const otherNews = blogPosts.filter(p => !newsItems.includes(p)).slice(0, 6);
  const allNews = [...newsItems, ...otherNews];

  return (
    <>
      <Navbar />
      <main className="bg-[#F9FBF5] min-h-screen">
        <section className="pt-20 lg:pt-32 pb-16">
          <div className="max-w-[1121px] mx-auto px-6 lg:px-10">
            <h1 className="text-[#082900] text-[36px] lg:text-[64px] font-light leading-[1.05] tracking-[-0.011em] mb-4">
              Newsroom
            </h1>
            <p className="text-[#082900]/60 text-[16px] lg:text-[18px] font-normal max-w-2xl mb-16">
              The latest news, announcements, and updates from Duty AI.
            </p>

            {/* Featured article */}
            {newsItems.length > 0 && (
              <Link to={`/blog/${newsItems[0].slug}`} className="block group mb-16">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                  <div className="aspect-[16/10] rounded-2xl overflow-hidden bg-[#e8ebe0]">
                    <img src={newsItems[0].image} alt={newsItems[0].title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div>
                    <span className="inline-block text-[#082900]/50 text-[13px] font-normal uppercase tracking-wider mb-3">{newsItems[0].category}</span>
                    <h2 className="text-[#082900] text-[24px] lg:text-[36px] font-light leading-[1.1] mb-4 group-hover:underline">{newsItems[0].title}</h2>
                    <p className="text-[#082900]/60 text-[14px] lg:text-[16px] font-normal leading-relaxed mb-4">{newsItems[0].excerpt}</p>
                    <span className="text-[#082900] text-[14px] font-normal flex items-center gap-1 group-hover:gap-2 transition-all">
                      Read more <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </Link>
            )}

            {/* News grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {allNews.slice(1).map((item, i) => (
                <Link key={i} to={`/blog/${item.slug}`} className="block group">
                  <div className="aspect-[16/10] rounded-xl overflow-hidden bg-[#e8ebe0] mb-4">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <span className="text-[#082900]/50 text-[12px] font-normal uppercase tracking-wider">{item.category}</span>
                  <h3 className="text-[#082900] text-[16px] lg:text-[18px] font-normal leading-[1.2] mt-2 group-hover:underline">{item.title}</h3>
                  <p className="text-[#082900]/50 text-[13px] font-normal mt-2">{item.readTime}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default NewsroomPage;
